import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {AppService} from '../app.service';
import {Subscription} from 'rxjs';
import {HarmonogramItem} from '../model/HarmonogramItem';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ZapisnyList} from '../model/zapisnyList';

@Component({
  selector: 'app-harmonogram-roka',
  templateUrl: './harmonogram-roka.component.html',
  styleUrls: ['./harmonogram-roka.component.css']
})
export class HarmonogramRokaComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  public data: HarmonogramItem[] = [];

  constructor(
      private appService: AppService,
      @Inject(MAT_DIALOG_DATA) public zapisnyList: ZapisnyList
  ) { }

  ngOnInit(): void {
    this.subscription = this.appService.harmonogramSubject
        .subscribe((data) => {
          this.data = data;
        });

    this.appService.retrieveHarmonogram(this.zapisnyList);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
